import _ from 'lodash'
import Backbone from 'backbone'
import i18n from 'scoreboard/components/i18n'
import DatasetDateFilterStep2 from 'scoreboard/datasets/filters/datasets-date-filter-step2'
import FormView from 'scoreboard/components/form-view'
import DataType from 'scoreboard/datasets/model/data-type'
const { DATE } = DataType

/* Report Date Filter Step 2 that is an adapter for the Datasets Date Filter Step 2 which does the actual date filter
 * implementation
 */
const DateFilter = DatasetDateFilterStep2.extend({

	className: 'report-filters',

	initialize: function(options = {}) {
		this.options = options
		this.data = options.data || {}
		this.options.filter = this.data
		this.options.allowAppCalendar = true

		let dataType = DATE
		//adapter for dataset model which defines getUnderlyingField. not very elegant but i think refactoring
		//the dataset specific date filters would be a moderate effort
		this.options.model = _.extend(new Backbone.Model(), {
			combinedFieldsById: {},
			getUnderlyingField() {
				return {dataType}
			}
		})
		//the underlying view expects an object
		this.field = {dataType}
		this.formView = new FormView({
			el: this.el,
			submit: this.submit.bind(this),
			guard: false,
			allowCleanSubmission: true
		})
	},

	context: function() {
		return {
			title: i18n.get('report.wizard.filter.dialog.title', this.options.nameCode)
		}
	},

	render () {
		DatasetDateFilterStep2.prototype.render.apply(this, arguments)
		//temporary hide equations until #16390 is implemented
		this.$('.update-type').addClass('is-not-displayed')
		return this
	},

	gather: function() {
		this.data = this.picker.val()
		return this.data
	},

	submit: function() {
		this.trigger('done', this.gather())
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.dateFilter], 'remove')
	}

})

export default DateFilter

DateFilter.__filename__ = 'reports/common/filter/date-filter-step2.js'
